import { reclaimActivationEntrySources } from "@redotech/redo-model/disputes/reclaim-access-settings";
import * as z from "zod";

export const enableDisputes = {
  name: "enableDisputes" as const,
  input: z.object({
    entrySource: z.enum(reclaimActivationEntrySources).optional(),
  }),
  output: z.object({
    status: z.enum([
      "trial_started",
      "trial_already_active",
      "billing_already_enabled",
      "free_access_enabled",
      "billing_required",
    ]),
  }),
};
